import {
  categoryId,
  money,
  type Category,
  type CategoryDetail,
  type CategoryNode,
} from '@sshop/domain';

import type { CategoryDetailDto, CategoryDto, CategoryNodeDto } from './category.dto';

export function toCategory(dto: CategoryDto): Category {
  return {
    id: categoryId(dto.id),
    slug: dto.slug,
    name: dto.name,
    description: dto.description,
    parentId: dto.parent_id !== null ? categoryId(dto.parent_id) : null,
    imageUrl: dto.image_url,
    iconUrl: dto.icon_url ?? dto.image_url,
    productCount: dto.product_count,
    onPage: dto.on_page,
  };
}

export function toCategoryNode(dto: CategoryNodeDto, depth = 0): CategoryNode {
  const resolvedDepth = dto.depth ?? depth;
  return {
    ...toCategory(dto),
    depth: resolvedDepth,
    children: (dto.children ?? []).map((child) => toCategoryNode(child, resolvedDepth + 1)),
  };
}

export function toCategoryTree(dtos: readonly CategoryNodeDto[]): readonly CategoryNode[] {
  return dtos.map((node) => toCategoryNode(node, 0));
}

export function toCategoryDetail(dto: CategoryDetailDto): CategoryDetail {
  return {
    id: categoryId(dto.id),
    slug: dto.slug,
    name: dto.name,
    description: dto.description,
    parentId: dto.parent_id !== null ? categoryId(dto.parent_id) : null,
    imageUrl: dto.image_url,
    iconUrl: dto.icon_url ?? dto.image_url,
    onPage: dto.on_page,
    ancestors: dto.ancestors.map((a) => ({
      id: categoryId(a.id),
      slug: a.slug,
      name: a.name,
    })),
    children: dto.children.map((c) => ({
      id: categoryId(c.id),
      slug: c.slug,
      name: c.name,
      imageUrl: c.image_url,
      iconUrl: c.icon_url ?? c.image_url,
    })),
    priceRange: {
      min: dto.price_range.min !== null ? money(dto.price_range.min, 'GEL') : null,
      max: dto.price_range.max !== null ? money(dto.price_range.max, 'GEL') : null,
    },
  };
}
